import {UserInfo} from "../types/interfaces";
/**
 * Format date fields for better display
 *
 * This function handles date formatting with timezone consideration
 * to ensure consistent date display across all browsers and devices.
 *
 * @param dateString - The date string from API response
 * @returns Formatted date string in day-month-year format
 */
export const formatDate = (dateString: string | null | undefined) => {
    if (!dateString) return 'N/A';
    try {
        // Parse date parts directly from the string to avoid timezone issues
        // Expected format: "YYYY-MM-DDT00:00:00.000+00:00" or similar
        const parts = dateString.split('T')[0].split('-');
        if (parts.length === 3) {
            const year = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1; // JS months are 0-based
            const day = parseInt(parts[2]);

            // Create date using UTC to avoid timezone shifts
            const date = new Date(Date.UTC(year, month, day));
            return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
        }

        // Fallback to regular date parsing if the format is different
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch (error) {
        console.error('Error formatting date:', dateString, error);
        return dateString || 'N/A';
    }
};

/**
 * Extract first and last name from a full name string
 *
 * @param fullName - The complete name string
 * @returns Object containing firstName and lastName
 */
export const extractNames = (fullName: string | null | undefined) => {
    if (!fullName) return { firstName: 'N/A', lastName: 'N/A' };

    const nameParts = fullName.trim().split(' ');
    if (nameParts.length === 1) return { firstName: nameParts[0], lastName: '' };

    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(' ');

    return { firstName, lastName };
};


// Format date for input fields (YYYY-MM-DD)
export const formatInputDate = (dateString: string) => {
    if (!dateString) return '';
    try {
        // Parse date parts directly from the string to avoid timezone issues
        // Expected format: "YYYY-MM-DDT00:00:00.000+00:00" or similar
        const parts = dateString.split('T')[0].split('-');
        if (parts.length === 3) {
            // Return the YYYY-MM-DD part directly
            return `${parts[0]}-${parts[1]}-${parts[2]}`;
        }

        // Fallback to regular date parsing if the format is different
        const date = new Date(dateString);
        // Format as YYYY-MM-DD for input field
        return date.toISOString().split('T')[0];
    } catch (e) {
        console.error('Error formatting input date:', dateString, e);
        return '';
    }
};

export const isSessionStorageItemExists = (key: string): boolean => {
    const value = sessionStorage.getItem(key);
    return value !== null;
};

export const getLoggedInUser = async () => {
    const user : UserInfo = await JSON.parse(sessionStorage.getItem('userInfo') || '{}');
    if (!user) return null;
    return user;
}

